export default __webpack_public_path__ + "static/media/bandsRate.af60075e.svg";